<template>
  <AppMessage
    :heading="heading"
    :duration="5000"
  >
    <template v-if="options.op === 'add'">
      {{ $t(
        '"%(assetName)s" was added to Favorites.',
        { assetName: decodeHTML(options.assetName), interpolation: { escapeValue: false } })
      }}
    </template>
    <template v-else>
      {{ $t(
        '"%(assetName)s" was removed from Favorites.',
        { assetName: decodeHTML(options.assetName), interpolation: { escapeValue: false } })
      }}
    </template>
  </AppMessage>
</template>

<script>
import { decodeHTML } from '@/lib/utils';
import AppMessage from './AppMessage.vue';

export default {
  name: 'QuickListMessage',
  components: {
    AppMessage,
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      decodeHTML,
    };
  },
  computed: {
    heading() {
      return this.options.op === 'add'
        ? this.$t('Added to Favorites')
        : this.$t('Removed from Favorites');
    },
  },
};
</script>
